import { useDispatch, useSelector } from "react-redux"
import { getActiveDevice, getPointedDeviceId } from "../../../reducers/devices";
import { setPointedDevice, transferDevice } from "../../../actions/devicesActions";
import { isPlaying } from "../../../reducers/playbackState";
import { ListItemIcon, ListItemText, MenuItem, Typography } from "@mui/material";
import { DEVICE_ITEM_ICON_SIZE } from "../../../utils/constants/viewConstants";
import { getActiveIcon, getDeviceIcon } from "../../../utils/iconUtils";

const DeviceItem = ({device, onClickDevice}) => {
    const activeDevice = useSelector(getActiveDevice);
    const pointedDeviceId = useSelector(getPointedDeviceId);
    const playing = useSelector(isPlaying);
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(activeDevice ?
            transferDevice(device, playing) :
            setPointedDevice(device));
        onClickDevice();
    };

    const isPointedDevice = (deviceId) => {
        return pointedDeviceId === deviceId;
    };

    return (
        <MenuItem onClick={onClick}>
            <div className="d-flex flex-row gap-1 ai-center jc-space-between full-width">
                <ListItemIcon style={{ fontSize: DEVICE_ITEM_ICON_SIZE }}>
                    {getDeviceIcon(device.type)}
                </ListItemIcon>
                <ListItemText><Typography noWrap>{device.name}</Typography></ListItemText>
                <ListItemIcon style={{ fontSize: DEVICE_ITEM_ICON_SIZE }}>
                    {getActiveIcon(isPointedDevice(device.id))}
                </ListItemIcon>
            </div>
        </MenuItem>
    );
}

export default DeviceItem;